import { createElement, useEffect, useRef } from 'react';
import styles from './timeline.module.less';
import { useLocation } from 'react-router-dom';

const Element = ({ tag, children, ...props }) => createElement(tag, { ...props }, children);

const SimpleItem = ({ titleClass, title, subtitle, description, tag = 'div' }) => {
    return (
        <Element className={styles.textBlock} tag={tag}>
            <div className={[styles.timelineItemTitle, titleClass].join(' ')}>{title}</div>
            <div className={styles.itemSubtitle}>{subtitle}</div>
            {description}
        </Element>
    );
};

const TimelineItem = ({ className, children, id, ...props }) => {
    const elementRef = useRef(null);
    const location = useLocation();
    useEffect(() => {
        if (elementRef.current && location.hash === `#${id}`) {
            elementRef.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
    }, [location, id]);

    return (
        <li className={[styles.item, className].join(' ')} ref={elementRef}>
            <span className={styles.circle} />
            {children || <SimpleItem {...props} />}
        </li>
    );
};

export default TimelineItem;
